import * as DialogPrimitive from "@radix-ui/react-dialog";

export const DialogPortal = DialogPrimitive.Portal;

DialogPortal.displayName = DialogPrimitive.Portal.displayName;
